'use strict';

exports.BOSTON_SFDC_OWNER = '0056A000001jTCx';
exports.NEW_YORK_SFDC_OWNER = '0056A000001k4NR';
exports.DC_SFDC_OWNER = '0056A000001kDt9';
exports.OOM_SFDC_OWNER = '0056A000001kGka';
exports.DEFAULT_SFDC_OWNER = exports.NEW_YORK_SFDC_OWNER;

exports.CITY_TO_SFDC_OWNER = {
  'New York': exports.NEW_YORK_SFDC_OWNER,
  'DC Metro Area': exports.DC_SFDC_OWNER,
  'Boston Area': exports.BOSTON_SFDC_OWNER,
  'Chicago': exports.OOM_SFDC_OWNER,
  'San Francisco Bay Area': exports.OOM_SFDC_OWNER,
  'Greater Los Angeles': exports.OOM_SFDC_OWNER
};